<template>
  <div class="letter-container">
    <div class="letter-box">
      <div class="letter-wrapper">
        <div>
          <div class="cover-top">
            <img style="width:100%" src="../../assets/images/activity/thanksLetter/juanzhou.png" />
          </div>
          <div>
            <div class="content" :style="{height: height + 'px'}" :class="{'contentHeight': showOpen}">
              <div class="height-60" style="margin-bottom:40px">
                <div style="padding-top:50px">您来到易加网已经{{baseInfo.totalDays}}天了!</div>
              </div>

              <div style="margin-bottom:80px">
                <img style="width: 180px;" src="../../assets/images/activity/thanksLetter/icon-day.png" alt="">
              </div>

              <div class="height-60" v-show="baseInfo.firstItem">
                初次见面，您选了<br>{{baseInfo.firstItem}}
              </div>

              <div v-show="baseInfo.friendFavoriteConvertItem">
                您的伙伴们都喜欢{{baseInfo.friendFavoriteConvertItem}}
              </div>

              <div style="padding-top:20px;margin-bottom:40px">
                <img style="width: 120px;" src="../../assets/images/activity/thanksLetter/thanks-letter-2020_prize-1.png" alt="">
              </div>

              <div class="height-60" v-show="baseInfo.favoriteItemCategory">
                您最爱{{baseInfo.favoriteItemCategory}}类礼品<br>小易努力去更新！
              </div>

              <div class="height-60" v-show="baseInfo.friendFavoriteItemCategory">
                我猜您最喜欢{{baseInfo.friendFavoriteItemCategory}}类礼品<br>小易努力去更新！
              </div>

              <div style="padding-top:80px">
                <div class="height-60" v-show="baseInfo.acquisitionPointTotal !== 0">
                  勤劳的您收获了{{baseInfo.acquisitionPointTotal}}积分<br>新的一年也要加油哦！
                </div>

                <div class="height-60" v-show="baseInfo.acquisitionPointTotal === 0">
                  小伙伴们收获了1.3亿积分<br>新的一年你也要加油哦！
                </div>

                <div style="padding-top:20px;margin-bottom:40px">
                  <img style="width: 120px;" src="../../assets/images/activity/thanksLetter/thanks-letter-2020_prize-2.png" alt="">
                </div>

                <div class="height-60" v-show="baseInfo.expenditurePointTotal !== 0">
                  能干的您消耗了{{baseInfo.expenditurePointTotal}}积分<br>小易一直在易加等你呀！
                </div>

                <div class="height-60" v-show="baseInfo.expenditurePointTotal === 0">
                  迈出第一步就是最帅气的开局！<br>小易在易加网等你呀！
                </div>
              </div>

              <div class="height-60">
                年度关键字：<span style="color:#c51819">{{baseInfo.yearKeyword}}</span>
              </div>
              <div>
                <img class="share-img" @click="getPoster()" style="width:40%" src="../../assets/images/activity/thanksLetter/share-btn.png" />
              </div>
            </div>
          </div>
          <div class="cover-bottom">
            <img style="width:100%" src="../../assets/images/activity/thanksLetter/juanzhou.png" />
          </div>
          <!-- <div class="open-icon">
            <img style="width:100%" src="../../assets/images/activity/thanksLetter/open-icon.png" />
          </div> -->
        </div>
      </div>
    </div>
    <div class="letter-rules">
      <img width="20%" src="../../assets/images/activity/thanksLetter/extra.png" />
      <p>活动说明：</p>
      <p>1、点击“转发集赞”，生成专属海报；</p>
      <p>2、在活动期内，集赞数前3名将获得大奖一份；</p>
      <p>3、本活动针对博世易加网IAM修理厂；</p>
      <p>4、本活动有效期至2021年1月13日；</p>
      <p>5、活动结束后电话通知中奖用户。</p>
    </div>
  </div>
</template>
<script>
import { userUtils } from '../../utils/auth'
import activityApi from '../../api/activity.js'
export default {
  data () {
    return {
      clientInfo: '',

      baseInfo: {
        totalDays: '',
        firstItem: '',
        favoriteItemCategory: '',
        acquisitionPointTotal: '',
        expenditurePointTotal: '',
        yearKeyword: '',
        friendFavoriteConvertItem: '',
        friendFavoriteItemCategory: '',
        friendPointTotal: ''
      },

      supportTotalCount: '',
      showOpen: false,

      // distance: '',
      // startY: '',
      // moveX: '',
      // moveY: '',

      height: 10

      // bottomY: 20,
      // tempY: ''
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo()
    console.log(this.clientInfo)
    if (!this.clientInfo) {
      this.$router.replace({
        name: 'login',
        params: {
          redirectUrl: '2020ThanksLetter'
        }
      })
    } else {
      this.queryDetails()
    }
  },
  mounted () {
    this.openLetter()
  },
  methods: {
    openLetter () {
      setTimeout(() => {
        this.showOpen = true
      }, 1000)
    },
    queryDetails () {
      activityApi.thanksLetterDetails().then(res => {
        if (res.data.resultCode === '0') {
          const thanksLetterObj = res.data.resultData.thanksLetter2020VO || ''

          let { totalDays, firstItem, favoriteItemCategory, acquisitionPointTotal, expenditurePointTotal, yearKeyword, friendFavoriteConvertItem, friendFavoriteItemCategory, friendPointTotal } = thanksLetterObj
          this.baseInfo.totalDays = totalDays
          this.baseInfo.firstItem = firstItem || ''
          this.baseInfo.favoriteItemCategory = favoriteItemCategory || ''
          this.baseInfo.acquisitionPointTotal = acquisitionPointTotal
          this.baseInfo.expenditurePointTotal = expenditurePointTotal
          this.baseInfo.yearKeyword = yearKeyword || ''
          this.baseInfo.friendFavoriteConvertItem = friendFavoriteConvertItem || ''
          this.baseInfo.friendFavoriteItemCategory = friendFavoriteItemCategory || ''
          this.baseInfo.friendPointTotal = friendPointTotal || ''
        }
      }).catch(err => {
        console.log(err)
      })
    },

    getPoster () {
      this.$router.replace({ path: '/activity/thanks-letter-poster-2020' })
    }

    // bodyTouchStart (ev) {
    //   // 起点坐标
    //   this.startX = ev.targetTouches[0].pageX
    //   this.startY = ev.targetTouches[0].pageY
    // },
    // bodyTouchMove (ev) {
    //   ev.preventDefault()

    //   this.moveX = ev.targetTouches[0].pageX
    //   this.moveY = ev.targetTouches[0].pageY

    //   this.distance = this.moveY - this.startY
    //   this.tempY = this.distance + this.bottomY

    //   if (this.tempY < 20 || this.tempY > 435) {
    //     return
    //   }
    //   this.bottomY = this.tempY
    //   this.height = this.height + this.distance
    //   this.startY = this.moveY
    // },
    // bodyTouchEnd () {
    // }
  }
}
</script>
<style lang="less" scoped>

@font-face{
    font-family: 'Huawenlishu';
    src : url('../../assets/fonts/huawenlishu.ttf');
}
.height-60 {
  height: 60px;
}
.height-80 {
  height: 80px;
}
.letter-container {
  width: 375px;
  height: 667.5px;
  background-image: url('../../assets/images/activity/thanksLetter/letter-bg.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.letter-box {
  height: 666.5px;
}
.alignCenter {
  text-align: center;
}
.poster {
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
}
.letter-wrapper {
  padding-top: 50px;
  .cover-top, .cover-bottom {
    width: 320px;
    padding-left: 20px;
  }
  .cover-bottom {
    margin-top: -18px;
  }
  .content {
    width: 270px;
    margin: -21px auto 0;
    padding: 0 12px;
    background-image: url('../../assets/images/activity/thanksLetter/content.png');
    background-repeat: repeat-y;
    background-size: 100%;
    opacity: 0.95;
    text-align: center;
    overflow: hidden;
    vertical-align: middle;
    font-family: "华文隶书", "Huawenlishu", "PingFang SC", "Heiti SC", "Droidsansfallback", "Helvetica", "sans-serif";
    font-size: 16px;
    box-sizing: border-box;
    transition: 5s;
    overflow: scroll;
    -webkit-overflow-scrolling: auto;
    .content-bg {
      width: 100%;
      position: relative;
      background-image: url('../../assets/images/activity/thanksLetter/text-bg.png');
      background-repeat: repeat-y;
      background-size: 100%;
    }
    .content-text {
      padding: 10px;
    }
  }
  .content>div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    box-sizing: border-box;
    flex-wrap: wrap;
  }
  .contentHeight {
    height: 420px !important;
  }
}
.open-icon {
  position: relative;
  width: 40px;
  z-index: 1;
  margin-top: -40px;
  left: 82%;
}
.letter-rules {
  position: relative;
  width: 100%;
  min-height: 180px;
  padding: 20px;
  background-color: #1d494f;
  color: #ffffff;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 1px;
  box-sizing: border-box;
  img {
    position: absolute;
    right: 20px;
    top: -25px;
  }
}
.share-img {
  animation: sharemove 4s infinite ease-in-out;
}
@keyframes sharemove
{
  0%{
  transform: scale(1);
  }
  25%{
      transform: scale(1.1);
  }
  50%{
      transform: scale(1);
  }
  75%{
      transform: scale(1.1);
  }
}
</style>
